import { FrequencyType, WeekDays } from '@business/entities/stat_collection';

export function getAllFrequencyTypes() {
  return [FrequencyType.daily, FrequencyType.weekly, FrequencyType.monthly];
}

export function getAllWeekDays() {
  return [WeekDays.sunday, WeekDays.monday, WeekDays.tuesday, WeekDays.wednesday, WeekDays.thursday, WeekDays.friday, WeekDays.saturday];
}

export function getFrequencyTypeLabel(type: FrequencyType) {
  switch (type) {
    case FrequencyType.daily:
      return 'Daily';
    case FrequencyType.weekly:
      return 'Weekly';
    case FrequencyType.monthly:
      return 'Monthly';
  }
}

export function getFrequencyTypeItems() {
  return getAllFrequencyTypes().map(type => ({
    value: type,
    label: getFrequencyTypeLabel(type),
  }));
}

export function getEndOfDayItems() {
  const info = getEndOfDay();

  return Object.keys(info).map(key => ({
    value: key,
    label: key,
  }));
}

export function getEndOfDay() {
  return {
    '00:00': '00:00',
    '01:00': '01:00',
    '02:00': '02:00',
    '03:00': '03:00',
    '04:00': '04:00',
    '05:00': '05:00',
    '06:00': '06:00',
    '07:00': '07:00',
    '08:00': '08:00',
    '09:00': '09:00',
    '10:00': '10:00',
    '11:00': '11:00',
    '12:00': '12:00',
    '13:00': '13:00',
    '14:00': '14:00',
    '15:00': '15:00',
    '16:00': '16:00',
    '17:00': '17:00',
    '18:00': '18:00',
    '19:00': '19:00',
    '20:00': '20:00',
    '21:00': '21:00',
    '22:00': '22:00',
    '23:00': '23:00',
  };
}

export function getMonthCountItems() {
  const info = getMonthCount();

  return Object.keys(info).map(key => ({
    value: key,
    label: key,
  }));
}

export function getMonthCount() {
  return {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '10': '10',
    '11': '11',
    '12': '12',
    '13': '13',
    '14': '14',
    '15': '15',
    '16': '16',
    '17': '17',
    '18': '18',
    '19': '19',
    '20': '20',
    '21': '21',
    '22': '22',
    '23': '23',
    '24': '24',
    '25': '25',
    '26': '26',
    '27': '27',
    '28': '28',
    '29': '29',
    '30': '30',
    '31': '31',
  };
}
